module.exports = __webpack_public_path__ + "static/media/qualdo_brandmark.3e364845.svg";